import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import Langtrans from "../../components/Langtrans/Langtrans";
import Buttons from "../../components/Button/Button";
import "./Dashboard.scss";
import { useHistory } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import { listPayments } from "../../graphql/queries";
import moment from "moment";

const Payment = () => {
	const { t } = useTranslation();
	const history = useHistory();

	const [data, setdata] = useState([]);
	const getId = localStorage.getItem("email");

	const getPayments = async (getId) => {
		try {
			const productImages = await API.graphql(
				graphqlOperation(listPayments, {
					filter: {
						customerId: {
							eq: getId,
						},
					},
				}),
			);
			setdata(productImages.data.listPayments.items);
		} catch (error) {
			return error;
		}
	};

	useEffect(() => {
		getPayments(getId);
	}, []);

	return (
		<>
			<div className="home">
				<div className="left">
					<CustomerDashboard />
				</div>
				<div className="right">
					<div className="top">
						<h4>{t("payment")}</h4>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-arround",
							}}
						>
							<Buttons
								style={{ width: "180px" }}
								text={t("new-campaign")}
								onClick={() => history.push("/")}
							/>
							<Langtrans
								style={{ marginRight: "0px", marginTop: "0px", height: "36px" }}
								dashboard
							/>
						</div>
					</div>
					{data.length > 0 ? (
						<div
							className="bottom"
							style={{ minHeight: "87vh", maxHeight: "100%" }}
						>
							<hr />
							<table
								style={{ width: "100%", textAlign: "left" }}
								cellPadding="0"
								cellSpacing="0"
							>
								<thead>
									<tr style={{ textAlign: "center" }}>
										<th style={{ padding: "7px 0" }}>{t("no_payments")}</th>
										<th style={{ padding: "7px 0" }}>{t("sub-total")}</th>
										<th style={{ padding: "7px 0" }}>{t("del")}</th>
										<th style={{ padding: "7px 0" }}>{t("total")}</th>
										<th style={{ padding: "7px 0" }}>{t("created_at")}</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
										<td>
											<hr />
										</td>
									</tr>
									{data.map((data, ind) => {
										return (
											<tr style={{ textAlign: "center" }}>
												<td style={{ padding: "10px 0" }}>
													{t("payments") + " " + "#" + " " + (ind + 1)}
												</td>
												<td>{data.total} €</td>
												<td>{data.shipCharge} €</td>
												<td>{data.subTotal} €</td>
												<td>{moment(data.createdAt).format("ll")}</td>
												<td>
													<Buttons
														text={t("detail")}
														style={{ margin: "10px 0" }}
														onClick={() =>
															history.push({
																pathname: "/orderproduct",
																state: data,
															})
														}
													/>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					) : (
						<div className="bottom" style={{ height: "87vh" }}>
							<hr />
							<div className="bottom-top">
								<div
									className="card"
									style={{
										width: "50%",
										marginTop: "20%",
										textAlign: "center",
									}}
								>
									<div className="cal-div">
										<div>
											<h2>{t("no-campaign-launched")}</h2>
											<p style={{ textAlign: "center" }}>{t("first-sale")}</p>
											<Buttons
												text={`> ${t("my-campaign")}`}
												className="campaign-btn btn"
												style={{ marginTop: "13px" }}
												onClick={() => history.push("/")}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};
export default Payment;
